<template>
  <slice
    :id="block._key"
    v-waypoint="{
      active: true,
      callback: onWaypoint,
      options: intersectionOptions,
    }"
    class="slice--image-full"
    :class="{
      container: !isFull,
      image45: is4_5,
      'image-in-screen': imageInScreen,
      'image-height-auto': block.image_height_auto,
    }"
    :style="style"
  >
    <div class="slice__inner" :class="{ 'row-md justify-center': !isFull }">
      <div
        v-if="image"
        class="slice__image"
        :class="{
          'col-md-8': !isFull && !is4_5,
          'image-portrait': is4_5 && block.format === 'portrait',
        }"
      >
        <image-with-products
          :image-desktop="{
            image: image,
            sizes: size,
          }"
          :image-mobile="
            !block.image_height_auto
              ? {
                  image: image,
                  widths: [320, 414, 640, 769],
                }
              : undefined
          "
        />

        <p
          v-if="block.caption"
          class="slice--image-full__caption text-small text-italic"
        >
          {{ block.caption }}
        </p>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import ImageWithProducts from '@/components/Image/ImageWithProducts'
import { getSanityBunnyImageLink } from '@/utils/image'

export default {
  name: 'BlockImageFull',
  components: {
    Slice,
    ImageWithProducts,
  },
  props: { block: { type: Object, required: true } },

  data() {
    return {
      init: false,
      loading: false,
      imageInScreen: false,
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.2, 1], // [0.25, 0.75] if you want a 25% offset!
      },
    }
  },
  computed: {
    is4_5() {
      return this.block.size === '4:5'
    },
    isFull() {
      return this.block.size === 'full'
    },
    style() {
      if (this.block.image_height_auto) {
        return {
          backgroundColor: this.block.background_color,
        }
      }

      return {}
    },
    image() {
      if (!this.block.image?.image) return null

      if (this.is4_5) {
        if (this.block.format === 'portrait') {
          return {
            url: getSanityBunnyImageLink(this.block.image.image, {
              width: 640,
              height: 800,
            }),
            dimensions: {
              width: 640,
              height: 800,
            },
          }
        }

        return {
          url: getSanityBunnyImageLink(this.block.image.image, {
            width: 800,
            height: 640,
          }),
          dimensions: {
            width: 800,
            height: 640,
          },
        }
      }

      if (this.block.image_height_auto) {
        const ratio =
          this.block.image.image.image.dimensions.width /
          this.block.image.image.image.dimensions.height

        if (this.isFull) {
          return {
            url: getSanityBunnyImageLink(this.block.image.image, {
              width: 2000,
            }),
            dimensions: {
              width: 2000,
              height: Math.floor(2000 / ratio),
            },
          }
        }
        return {
          url: getSanityBunnyImageLink(this.block.image.image, {
            width: 720,
          }),
          dimensions: {
            width: 720,
            height: Math.floor(720 / ratio),
          },
        }
      }

      if (this.isFull) {
        return {
          url: getSanityBunnyImageLink(this.block.image.image, {
            width: 2000,
            height: 1140,
          }),
          dimensions: {
            width: 2000,
            height: 1140,
          },
        }
      }

      return {
        url: getSanityBunnyImageLink(this.block.image.image, {
          width: 960,
          height: 640,
        }),
        dimensions: {
          width: 960,
          height: 640,
        },
      }
    },
    size() {
      if (this.is4_5) {
        if (this.block.format === 'portrait') {
          return '640vw'
        }

        return '800w'
      }

      if (this.isFull) {
        return '100vw'
      }

      if (this.block.image_height_auto) {
        return '720px'
      }

      return '960px'
    },
  },
  methods: {
    onWaypoint({ going }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        this.imageInScreen = true
      }

      if (going === this.$waypointMap.GOING_OUT) {
        this.imageInScreen = false
      }
    },
  },
}
</script>

<style lang="scss">
.slice--image-full {
  transition: padding 0.6s;

  &__caption {
    color: var(--secondary-color-2);
    padding: calc(var(--spacing) * 0.5) var(--spacing);
    max-width: none;

    @include mq($from: tablet) {
      padding: calc(var(--spacing) * 0.5) 0;
    }
  }

  &.image-in-screen {
    &.container {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.image-height-auto {
    .image-with-products,
    .lazy-image.loaded {
      background: transparent;
    }

    &.container {
      .image-with-products {
        max-width: rem(720px);
        margin: 0 auto;
      }

      .slice--image-full__caption {
        max-width: rem(720px);
        margin: 0 auto;
      }
    }
  }

  &.image45 {
    .slice__image {
      width: rem(800px);
      max-width: 100%;

      &.image-portrait {
        width: rem(640px);
      }
    }
  }
}
</style>
